import { useEffect } from 'react';
import { useAccount } from 'wagmi';

import { useReferrerFromBlockchain, useUserAlreadyReferred } from 'utils/Hooks';
import {
  ClearReferrerFromLocalStorage, GetReferrerFromLocalStorage, SaveReferrerToLocalStorage
} from 'utils/Referrals';


/**
 * Ensures cross-chain compatibility by keeping referrer in local storage updated
 */
function CrossChainReferrerUpdater() {
  const userAlreadyReferred = useUserAlreadyReferred();
  const referrer_blockchain = useReferrerFromBlockchain();

  const account = useAccount();


  useEffect(() => {
    UpdateReferrer();
  }, [userAlreadyReferred, referrer_blockchain, account?.address])

  function UpdateReferrer() {
    const referrer_LocalStorage = GetReferrerFromLocalStorage();
    const referrerIsThisUser = (account?.address == referrer_LocalStorage);
    if (userAlreadyReferred && referrer_blockchain) {
      if (referrer_LocalStorage != referrer_blockchain)
        console.log(`Saving referrer from blockchain to LS: ${referrer_blockchain}`);
        SaveReferrerToLocalStorage(referrer_blockchain);
    } else if (referrerIsThisUser) {
      console.log('Clearing referrer from LocalStorage since it is current user\'s own address')
      ClearReferrerFromLocalStorage();
    }
  }

  return null; // don't need to render anything
}


export default CrossChainReferrerUpdater;